const module = { name: 'movie/reviews/desktop.app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_debugLog as debugLog } from 'require-core';



import { default as mopReviews } from 'swug-fdRequire-call:movie/shared/desktop/mopReviews';



import { default as ratingsTabs } from 'swug-fdRequire-call:movie/shared/desktop/movieRatingsTabs';



import { default as verifiedAudienceReview } from 'swug-fdRequire-call:movie/shared/desktop/verifiedAudienceReview';

function run() {
    checkDependencies(module.name, debugLog);
    mopReviews.init();
    ratingsTabs.init();
    verifiedAudienceReview.init();
}
run();
export default module.exports;